import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import swal from "sweetalert";
import MeasureTruckDistance from "../../component/frontend/PopUp/MeasureTruckDistance";
import UseFullPageLoader from '../../component/FullPageLoader/UseFullPageLoader';

const Navbar = () => {

    const history = useHistory();
    const [modalShow, setModalShow] = React.useState(false);
    const [loader, showLoader, hideLoader] = UseFullPageLoader();
    const [showVideo, setShowVideo] = useState(false);


     //assigning location variable
     const location = useLocation();

     //destructuring pathname from location
     const { pathname } = location;
 
     //Javascript split method to get the name of the path in array
     const splitLocation = pathname.split("/");
     const authToken = localStorage.getItem('auth_token');
     const authName = localStorage.getItem('auth_name');
     const userId = localStorage.getItem('user_id');
     const userType = localStorage.getItem('type');

     const data = {
        auth_token: authToken,
        user_id: userId,
        auth_name: authName,
        user_type: userType,
    }

    const logoutSubmit = (e) => {
        showLoader(); 
        e.preventDefault();
        axios.post('/api/user/logout',data).then(res => {
            if (res.data.status_code === 200) {
                hideLoader();
                localStorage.removeItem('auth_token');
                localStorage.removeItem('auth_name');
                localStorage.removeItem('user_id');
                localStorage.removeItem('type');
                swal({ position: 'top-end', icon: 'success', title: res.data.message, showConfirmButton: false, timer: 1500 });
                history.push('/');
            } else {

            }
        }).catch(error => {
            console.log(error)
        });
    }


    var authButtons = '';
    if (!localStorage.getItem('auth_token')) {
        authButtons = (
            <Link className="button customButton01" to="/login">
                <i className="fa fa-user-o heart-icon-post-listing" aria-hidden="true"></i> Login
            </Link>
        );
    } 
    // else {
    //     authButtons = (
    //         <button type="button" onClick={logoutSubmit} className="button customButton01 customButton01Nav btn-danger">
    //             <i className="fa fa-user-o heart-icon-post-listing" aria-hidden="true"></i> Logout
    //         </button>
    //     );
    // }


    var manageProfileBtn = '';
    if (localStorage.getItem('auth_token')) {
        manageProfileBtn = (
            <Link to={`/manage-profile/${userId}`} className="customButton01 customButton01Nav">
            <i className="fa fa-user" aria-hidden="true"></i>Manage Profile
        </Link>
        );
    } 

    var favBtn = '';
    var nearbyBtn = '';
    if (localStorage.getItem('auth_token')) {
        favBtn = (
            <Link className={splitLocation[1] === "favorite" ? "button customButton01 active customButton01Nav" : "button customButton01 customButton01Nav"} to="/favorite">
            <i className="fa fa-heart-o heart-icon-post-listing" aria-hidden="true"></i>Favorites
        </Link>
        );

        nearbyBtn = (
            <Link className={splitLocation[1] === "nearby-posts" ? "button customButton01 active customButton01Nav" : "button customButton01 customButton01Nav"} to="/nearby-posts">
            <i className="fa fa-location-arrow heart-icon-post-listing" aria-hidden="true"></i>Nearby Trucks
        </Link>
        );
    } 

    return (
       <>
        <header className="sb-nav-fixed">
            <nav className="navbar navbar-expand-lg">
                <div className="container-fluid">
                    <Link className="navbar-brand" to="/">
                        <img src={"/frontend/images/logo.png"} alt="DirtMap" className="imgResponsive" />
                    </Link>
                    <button className="navbar-toggler orangeBg" type="button" data-toggle="collapse"
                        data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false"
                        aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                        <span className="navbar-toggler-icon"></span>
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarResponsive">
                        <ul className="navbar-nav ml-auto">
                            {/* <li className={splitLocation[1] === "" ? "nav-item active" : "nav-link"}>
                                <Link className="nav-link" to="/">Search Item<span
                                    className="sr-only">(current)</span>
                                </Link>
                            </li> */}


                            {/* <li className="nav-item">
                                <Link className="nav-link" to="post-items.html">Post Your Site</Link>
                            </li> */}

                            

                            {/* <li className="nav-item">
                                <Link to="/" className="nav-link" onClick={() => setModalShow(true)}>
                                    Measure Truck distance
                                </Link>
                            </li>
                            
                            <MeasureTruckDistance
                                show={modalShow}
                                onHide={() => setModalShow(false)}
                            />
                            <li className={splitLocation[1] === "" ? "nav-item active" : "nav-link"}>
                                <Link className="nav-link" to="/">Measure Truck distance                                </Link>
                            </li> */}

                        </ul>

                        <div className="actionButtons headerButtons">

                            

                            {/* {manageProfileBtn}

                            {authButtons} */}

                 
                            {localStorage.getItem("auth_token") && (
                            <div className="dropdown">
                                {nearbyBtn}

                            {favBtn}
                                <button
                                className="button customButton01 customButton01Nav dropdown-toggle"
                                type="button"
                                id="profileDropdown"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                >
                                <i className="fa fa-user" aria-hidden="true"></i> My Profile
                                </button>

                                <div className="dropdown-menu dropdown-menu-right" aria-labelledby="profileDropdown">
                                <Link className="dropdown-item" to={`/manage-profile/${userId}`}>
                                    <i className="fa fa-user-circle" aria-hidden="true" style={{ marginRight: 8 }}></i>
                                    Manage Profile
                                </Link>
                                <Link className="dropdown-item" to={`/change-password`}>
                                    <i className="fa fa-key" aria-hidden="true" style={{ marginRight: 8 }}></i>
                                    Change Password
                                </Link>
                                {localStorage.getItem("auth_token") && userType === "normal" && (
                                <Link className="dropdown-item" to="/my-posts">
                                    <i className="fa fa-list" aria-hidden="true" style={{ marginRight: 8 }}></i>
                                    My Posts
                                </Link>
                                )}

                                <Link
                                    className="dropdown-item"
                                    to="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setShowVideo(true);
                                    }}
                                >
                                    <i
                                        className="fa fa-play-circle"
                                        aria-hidden="true"
                                        style={{ marginRight: 8 }}
                                    ></i>
                                    Video Tutorial
                                </Link>

                                <div className="dropdown-divider"></div>

                                <button className="dropdown-item" onClick={logoutSubmit} type="button">
                                    <i className="fa fa-sign-out" aria-hidden="true" style={{ marginRight: 8 }}></i>
                                    Logout
                                </button>
                                </div>
                            </div>
                            )}
                             {authButtons} 
                        </div>
                    </div>
                </div>
            </nav>
            {loader}
        </header>

            {showVideo && (
                <div
                    className="modal fade show"
                    style={{
                        display: "block",
                        backgroundColor: "rgba(0,0,0,0.5)"
                    }}
                >
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Video Tutorial
                                </h5>

                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowVideo(false)}
                                />
                            </div>

                            <div className="modal-body">
                                <video
                                    width="100%"
                                    controls
                                    autoPlay
                                >
                                    <source
                                        src="/landscapeDirt20-june.mp4"
                                        type="video/mp4"
                                    />
                                </video>
                            </div>

                        </div>
                    </div>
                </div>
            )}

        </>    
    )
}
export default Navbar;